import React from 'react'
import { object, string } from 'prop-types'
import ProfileHeader from '@/component/Primitive/ProfileHeader'
import ProfileLink from '@/component/Primitive/ProfileHeader/component/ProfileLink'
import changeFileExtension from '@/lib/filename-extension-modifier'

const ExecutiveProfile = ({ pageData, latestCompanyReportUrl }) => {
  const { executive } = pageData

  const formattedExecutive = {
    heading: executive.name,
    subHeading: executive.jobTitle,
    description: executive.bio,
    src: executive.images.headshot_220x347_576[0].url,
    srcSet: [220, 576, 720, 900].map((size) => {
      return {
        width: size,
        src: changeFileExtension(
          executive.images[`headshot_220x347_${size}`][0].url,
          'webp'
        )
      }
    }),
    imageRatio: 347 / 220
  }

  return (
    <ProfileHeader {...formattedExecutive}>
      {executive.linkedinId && (
        <ProfileLink
          url={`https://www.linkedin.com/in/${executive.linkedinId}`}
          type="linkedin"
        >
          Follow on LinkedIn
        </ProfileLink>
      )}
      {latestCompanyReportUrl && (
        <ProfileLink to="/article" as={latestCompanyReportUrl}>
          Company Report
        </ProfileLink>
      )}
    </ProfileHeader>
  )
}

ExecutiveProfile.propTypes = {
  pageData: object,
  latestCompanyReportUrl: string
}

export default ExecutiveProfile
